/* ===================================================================
   useReports() -- real Reports-screen metrics (Hopper, 2026-06-17).

   Read: GET /api/v1/reports  (KPIs + chart series + by-platform split,
   the SAME honest series the CSV export is built from). Tenant-scoped by
   the token's client_id. Disabled until a Bearer rr_ token exists so it
   never auto-fires a 401.
   =================================================================== */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api, type ReportsResponse } from '../lib/api';
import { useApiToken } from './useApiToken';
import { qk } from './queryKeys';

export function useReports(): UseQueryResult<ReportsResponse, Error> {
  const hasToken = Boolean(useApiToken());
  return useQuery({
    queryKey: qk.reports(),
    queryFn: ({ signal }) => api.getReports(signal),
    enabled: hasToken,
    staleTime: 60_000,
  });
}
